module.exports = __webpack_public_path__ + "media/sprites.cea0c8ad.webm";